import { FormControlLabel, Switch } from '@material-ui/core';
import React from 'react';

export default ({ field, label, ...props }) => {
  const handleChange = (v) => {
    props.form.setFieldValue(field.name, !field.value)
  }

  return (
    <FormControlLabel
      label={label}
      control={<Switch
        inputProps={{ style: { margin: 0 } }}
        color="primary"
        checked={field.value}
        onChange={handleChange}
        size={props.size || 'medium'}
      />}
    />
  )
};
